import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from '../../../classes/customer';
import { CustomerService } from '../../../services/customer';
import { HttpErrorResponse } from '@angular/common/http';
import { normalizeCustomerEmails } from '../../../utils/customerEmails';

@Component({
    selector: 'app-customer-create-modal',
    templateUrl: './customer-create-modal.component.html',
    styleUrls: ['./customer-create-modal.component.css']
})
export class CustomerCreateModalComponent implements OnInit {
    customer: Customer = new Customer();
    emailInputs: string[] = [''];
    emailError: string = '';
    loadingCondition: boolean = false;

    constructor(public activeModal: NgbActiveModal,
                private customerService: CustomerService) {
    }

    ngOnInit(): void {
        this.customer.Enabled = true;
    }

    private formatDateInput(value: Date | string | null | undefined): string {
        if (!value) {
            return '';
        }
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
            return value.trim();
        }
        const date = new Date(value);
        if (isNaN(date.getTime())) {
            return '';
        }
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private parseDateInput(value: string): Date | null {
        if (!value) {
            return null;
        }
        const [y, m, d] = value.split('-').map(Number);
        return new Date(Date.UTC(y, m - 1, d));
    }

    get registrationDateString(): string {
        return this.formatDateInput(this.customer.RegistrationDate);
    }

    set registrationDateString(value: string) {
        this.customer.RegistrationDate = this.parseDateInput(value);
    }

    get visuraDateString(): string {
        return this.formatDateInput(this.customer.VisuraDate);
    }

    set visuraDateString(value: string) {
        this.customer.VisuraDate = this.parseDateInput(value);
    }

    get balanceDateString(): string {
        return this.formatDateInput(this.customer.BalanceDate);
    }

    set balanceDateString(value: string) {
        this.customer.BalanceDate = this.parseDateInput(value);
    }

    get birthDateString(): string {
        return this.formatDateInput(this.customer.BirthDate);
    }

    set birthDateString(value: string) {
        this.customer.BirthDate = this.parseDateInput(value);
    }

    onPasteIBAN(event: any) {
        event.preventDefault();
        let ibanPasted = event.clipboardData.getData('text');
        ibanPasted = ibanPasted.replace(/ /g, '');
        ibanPasted = ibanPasted.substring(0, 27).toUpperCase();
        this.customer.IBAN = ibanPasted;
    }

    onChangeIBAN(event: any) {
        this.customer.IBAN = event.replace(/ /g, '').toUpperCase();
    }

    createCustomer() {
        const parsed = normalizeCustomerEmails(this.emailInputs);
        if (parsed.error) {
            this.emailError = parsed.error;
            return;
        }
        this.emailError = '';
        this.loadingCondition = true;
        this.customer.Enabled = true;
        this.customer.Email = '';
        this.customer.emails = parsed.emails.map(email => ({ Email: email }));
        this.customerService.create(this.customer)
            .subscribe({
                next: (customerCreated: Customer) => {
                    this.loadingCondition = false;
                    this.activeModal.close(customerCreated);
                },
                error: (err: HttpErrorResponse) => {
                    this.loadingCondition = false;
                    console.log(err);
                }
            });
    }

}
